export default "__VITE_ASSET__BLRIIAT7__"